import {Component, tag} from 'doz'
import programOnAir from '../sections/programOnAir/programOnAir'
import LastSongs from '../sections/lastSongs/lastSongs'
import Stores from '../sections/stores'
import Contacts from '../sections/contacs'
import News from '../sections/news'
import Socials from '../sections/socials'
import Banner from '../sections/banner'
import Logo from "../sections/logo";
//import Banner2 from '../sections/banner2'
import Programs from '../sections/programs/programs'
import CustomHtml from '../sections/customHtml'
import PlayerHtml from '../sections/playerHtml'
import Podcasts from '../sections/podcasts/podcasts'
import arraySort from 'array-sort'

@tag('page-home')
export default class extends Component {

    sections = [];

    template(h) {
        return h`
            <div>
                ${this.sections.map(section => {
                    if (section.props && section.props.items) {
                        return h`<${section.cmp} items="${section.props.items}"/>`
                    } else {
                        return h`<${section.cmp}/>`
                    }
                })}
            </div>
            <footer d-show="${!!this.PLAYER_CONFIG.copyright && !this.PLAYER_CONFIG.isShowProgramsOnly}">
                <div>
                    <span style="font-size:11px;">Copyright © ${new Date().getFullYear()} ${this.PLAYER_CONFIG.copyright}</span>
                </div>
                <div d-show="${this.PLAYER_CONFIG.disableGA}" style="font-size: 10px">
                    Questo sito utilizza solo cookie tecnici necessari per il suo corretto funzionamento e non raccoglie dati personali degli utenti
                </div>
            </footer>
        `
    }

    onMount() {

        let sections = [{
            cmp: Logo, index: 0
        }];
        //todo temporary
        //this.PLAYER_CONFIG.podcastsIndex = 4;

        //console.log(this.PLAYER_CONFIG);

        if (this.PLAYER_CONFIG.lastSongsIndex > -1)
            sections.push({cmp: LastSongs, index: this.PLAYER_CONFIG.lastSongsIndex});

        if (this.PLAYER_CONFIG.programOnAirIndex > -1)
            sections.push({cmp: programOnAir, index: this.PLAYER_CONFIG.programOnAirIndex});

        if (this.PLAYER_CONFIG.newsIndex > -1)
            sections.push({cmp: News, index: this.PLAYER_CONFIG.newsIndex});

        if (this.PLAYER_CONFIG.contactsIndex > -1)
            sections.push({cmp: Contacts, index: this.PLAYER_CONFIG.contactsIndex});

        if (this.PLAYER_CONFIG.socialsIndex > -1)
            sections.push({cmp: Socials, index: this.PLAYER_CONFIG.socialsIndex});

        if (this.PLAYER_CONFIG.bannerIndex > -1) {
            sections.push({
                cmp: Banner,
                index: this.PLAYER_CONFIG.bannerIndex,
                props: {items: this.PLAYER_CONFIG.bannersSection1}
            });
        }

        if (this.PLAYER_CONFIG.banner2Index > -1) {
            sections.push({
                cmp: Banner,
                index: this.PLAYER_CONFIG.banner2Index,
                props: {items: this.PLAYER_CONFIG.bannersSection2}
            });
        }

        if (this.PLAYER_CONFIG.storesIndex > -1)
            sections.push({cmp: Stores, index: this.PLAYER_CONFIG.storesIndex});

        if (this.PLAYER_CONFIG.programsIndex > -1)
            sections.push({cmp: Programs, index: this.PLAYER_CONFIG.programsIndex});

        if (this.PLAYER_CONFIG.htmlIndex > -1)
            sections.push({cmp: CustomHtml, index: this.PLAYER_CONFIG.htmlIndex});

        if (this.PLAYER_CONFIG.playerIndex > -1)
            sections.push({cmp: PlayerHtml, index: this.PLAYER_CONFIG.playerIndex});

        if (this.PLAYER_CONFIG.podcastsIndex > -1)
            sections.push({cmp: Podcasts, index: this.PLAYER_CONFIG.podcastsIndex});

        this.sections = arraySort(sections || [], 'index');
        //console.log(sections);
        //this.render();

        this.metaTag({
            title: this.PLAYER_CONFIG.title,
            description: ''
        });
    }
}
